if (!customElements.get('linked-products')) {
  const norm = (value) =>
    String(value == null ? '' : value)
      .trim()
      .toLowerCase();

  const hasKeys = (obj) => !!obj && Object.keys(obj).length > 0;

  customElements.define(
    'linked-products',
    class extends HTMLElement {
      connectedCallback() {
        this.unsubscribeAll();

        const configEl = this.querySelector('script[data-linked-products-config]');
        if (!configEl) return;

        let config;
        try {
          config = JSON.parse(configEl.textContent);
        } catch (e) {
          return;
        }
        if (!config || !Array.isArray(config.siblings) || !config.siblings.length) return;
        this.config = config;

        this.sourceOptions = (this.config.sourceOptions || []).map(norm);
        this.duplicateOptionNames = new Set(
          this.sourceOptions.filter((name, i) => this.sourceOptions.indexOf(name) !== i)
        );
        this.scope = this.closest('product-info');
        this.sectionId = this.scope ? this.scope.dataset.originalSection || this.scope.dataset.section : null;
        this.awaitingVariantChange = false;

        let initial = null;
        const selectedEl = (this.scope || this).querySelector('[data-selected-variant]');
        if (selectedEl) {
          try {
            initial = this.selectionFromVariant(JSON.parse(selectedEl.textContent));
          } catch (e) {}
        }
        if (!hasKeys(initial) && Array.isArray(this.config.initialSelection)) {
          initial = this.selectionFromVariant({ options: this.config.initialSelection });
        }
        this.updateHrefs(hasKeys(initial) ? initial : null);

        if (!this.sectionId) return;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.optionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
          if (this.isStale()) return;
          const target = event?.data?.event?.target;
          if (!target || !this.scope) return;
          this.awaitingVariantChange = this.scope.contains(target);
          if (!this.awaitingVariantChange) return;
          this.updateHrefs(null);
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (this.isStale()) return;
          if (!event || !event.data) return;
          if (String(event.data.sectionId) !== String(this.sectionId)) return;
          if (!this.awaitingVariantChange) return;
          this.awaitingVariantChange = false;
          const selection = event.data.variant ? this.selectionFromVariant(event.data.variant) : null;
          this.updateHrefs(hasKeys(selection) ? selection : null);
        });
      }

      disconnectedCallback() {
        this.unsubscribeAll();
      }

      unsubscribeAll() {
        this.optionChangeUnsubscriber?.();
        this.optionChangeUnsubscriber = null;
        this.variantChangeUnsubscriber?.();
        this.variantChangeUnsubscriber = null;
      }

      isStale() {
        if (!this.isConnected) return true;
        if (!this.scope) return false;
        const live = document.querySelector(
          `product-info[data-section="${CSS.escape(this.scope.dataset.section || '')}"]`
        );
        return !!live && live !== this.scope;
      }

      findVariantId(sibling, selection) {
        const keys = Object.keys(selection || {});
        const sel = {};
        keys.forEach((key) => {
          sel[norm(key)] = selection[key];
        });
        if (Object.keys(sel).length !== keys.length) return null;

        const variants = sibling.variants || [];
        for (let i = 0; i < variants.length; i++) {
          const opts = variants[i].opts || {};
          const keys = Object.keys(opts);
          if (!keys.length) continue;
          if (typeof variants[i].optCount === 'number' && keys.length !== variants[i].optCount) continue;
          let full = true;
          for (let k = 0; k < keys.length; k++) {
            const nk = norm(keys[k]);
            if (!(nk in sel) || norm(sel[nk]) !== norm(opts[keys[k]])) {
              full = false;
              break;
            }
          }
          if (full) return variants[i].id;
        }
        return null;
      }

      selectionFromVariant(variant) {
        if (!variant || !Array.isArray(variant.options)) return null;
        const selection = {};
        variant.options.forEach((value, index) => {
          const name = this.sourceOptions[index];
          if (name && !this.duplicateOptionNames.has(name)) selection[name] = value;
        });
        return selection;
      }

      updateHrefs(selection) {
        this.config.siblings.forEach((sibling) => {
          const pill = this.querySelector(`[data-linked-pill="${CSS.escape(String(sibling.id))}"]`);
          if (!pill) return;
          const base = pill.getAttribute('data-base-url') || sibling.url;
          const variantId = selection ? this.findVariantId(sibling, selection) : null;
          const separator = base.indexOf('?') === -1 ? '?' : '&';
          pill.setAttribute('href', variantId ? `${base}${separator}variant=${variantId}` : base);
        });
      }
    }
  );
}
